import { REFERRAL, INITIAL_APP_STATE, LOGIN, FILTER_FIELD, PROPERTY } from '_constants';
import moment from 'moment';

export const referrals = (state = {}, action) => {
  let newState = { ...state };
  const activeReferralData = [];
  const inActiveReferral = [];
  const closedReferral = [];
  let allReferrals = null;
  let searchObj = '';
  let lastYear = '';
  let today = '';
  let filterOppByTime = '';
  switch (action.type) {
    case REFERRAL.ACTION.UPDATE_REFERRALS:
      allReferrals = action.value;
      lastYear = moment().subtract(1, 'year').startOf('day');
      today = moment().endOf('day');
      filterOppByTime = (updatedTime) => {
        if (!updatedTime) return false;
        return moment(updatedTime) >= lastYear && moment(updatedTime) <= today;
      };
      (allReferrals || []).map(item => {
        let isActiveReferral = false;
        let isClosedReferral = false;
        let isInActiveReferral = false;
        (((item && item.opportunities) || []).some(value => {
          if ((value.group === 'FALLOUT')) {
            isInActiveReferral = true;
            value.opportunityType = FILTER_FIELD.INACTIVE_REFERRAL;
          } else if (filterOppByTime(value && value.timestampModified)) {
            if ((value.status === 'Closed')) {
              isClosedReferral = true;
              value.opportunityType = FILTER_FIELD.CLOSE_REFERRAL;
            } else if ((value.status !== 'Closed') && (value.status !== 'Fallout') && (value.status !== undefined)) {
              isActiveReferral = true;
              value.opportunityType = FILTER_FIELD.ACTIVE_REFERRAL;
            }
          }
          if (isActiveReferral && isInActiveReferral && isClosedReferral) {
            return true;
          }
          return false;
        }
        ));
        isActiveReferral && activeReferralData.push(item);
        isInActiveReferral && inActiveReferral.push(item);
        isClosedReferral && closedReferral.push(item);
      });
      newState.activeReferralData = activeReferralData;
      newState.inActiveReferral = inActiveReferral;
      newState.closedReferral = closedReferral;
      newState.allReferrals = allReferrals;
      newState.searchReferrals = action.value;
      newState.searchHasValue = false;
      if (action.payload) { newState.activeReferral = action.payload; }
      break;
    case REFERRAL.ACTION.UPDATE_ALL_REFERRALS:
      allReferrals = action.value;
      (allReferrals || []).map(item => {
        (((item && item.opportunities) || []).some(value => {
          if ((value.group === 'FALLOUT')) {
            value.opportunityType = FILTER_FIELD.INACTIVE_REFERRAL;
          }
          if ((value.status === 'Closed')) {
            value.opportunityType = FILTER_FIELD.CLOSE_REFERRAL;
          } if ((value.status !== 'Closed') && (value.group !== 'FALLOUT') && (value.status !== undefined)) {
            value.opportunityType = FILTER_FIELD.ACTIVE_REFERRAL;
          }
        }
        ));
      });
      newState.allReferrals = allReferrals;
      if (action.payload) { newState.activeReferral = action.payload; }
      break;
    case REFERRAL.ACTION.SET_ACTIVE_REFERRAL:
      newState.opportunities = action.opportunities;
      newState.activeReferral = action.payload;
      newState.activeAppointment = action.activeAppointment;
      newState.activeOpportunity = action.activeOpportunity;
      break;
    case REFERRAL.ACTION.INITIALIZE_REFERRAL:
      newState.activeReferral = action.activeReferral;
      newState.opportunities = action.opportunities;
      newState.appointments = action.appointments;
      newState.activeOpportunity = action.activeOpportunity;
      newState.activeAppointment = action.activeAppointment;
      newState.documents = action.documents;
      newState.properties = action.properties;
      newState.buyOppStatusList = action.buyOppStatusList;
      newState.sellOppStatusList = action.sellOppStatusList;
      newState.additionalDocuments = action.additionalDocuments;
      break;
    case REFERRAL.ACTION.SEARCH:
      searchObj = action.value;
      newState.searchHasValue = !!searchObj.searchValue;
      break;
    case REFERRAL.ACTION.UPDATE_REFERRAL_DETAIL_CARD:
      newState.currentDetailCard = action.card;
      break;
    case REFERRAL.ACTION.RESET_REFERRAL_DETAIL:
      newState.activeReferral = null;
      newState.opportunities = null;
      newState.appointments = null;
      newState.activeOpportunity = null;
      newState.activeAppointment = null;
      newState.documents = null;
      newState.properties = null;
      newState.buyOppStatusList = null;
      newState.sellOppStatusList = null;
      break;
    case REFERRAL.ACTION.UPDATING_OPPORTUNITY: {
      const opportunityKey = action.payload.opportunityKey;
      const position = newState.opportunities.findIndex(x => x.opportunityKey === opportunityKey);
      newState.opportunities[position].notes = action.payload.notes || [];
    }
      break;
    case REFERRAL.ACTION.SET_ACTIVE_OPPORTUNITY:
      newState.activeOpportunity = action.payload;
      newState.buyOppStatusList = action.buyOppStatusList;
      newState.sellOppStatusList = action.sellOppStatusList;
      newState.fetchingOpportunity = true;
      break;
    case REFERRAL.ACTION.SET_OPPORTUNITIES:
      newState.opportunities = action.payload;
      break;
    case REFERRAL.ACTION.END_OPPORTUNITY_FETCH:
      newState.fetchingOpportunity = false;
      break;
    case REFERRAL.ACTION.START_OPPORTUNITY_FETCH:
      newState.fetchingOpportunity = true;
      break;
    case LOGIN.LOGOUT:
      newState = INITIAL_APP_STATE.referrals;
      break;
    case REFERRAL.ACTION.GET_FILTERED_REFFERAL:
      newState.searchReferrals = newState[action.payload];
      newState.activeReferralFilter = action.payload;
      break;
    case REFERRAL.ACTION.FETCH_CONTACT_INFO:
      newState.referralData = action.value;
      break;
    case REFERRAL.ACTION.FETCH_OPPORTUNITY_INFO:
      newState.opportunityData = action.value;
      break;
    case PROPERTY.START_SAVING_OPPORTUNITY_PROPERTY:
      newState.savingProperty = true;
      break;
    case PROPERTY.ERROR_SAVING_OPPORTUNITY_PROPERTY:
      newState.savingError = action.payload;
      break;
    case PROPERTY.END_SAVING_OPPORTUNITY_PROPERTY:
      newState.savingProperty = false;
      break;
    default:
      break;
  }
  return newState;
};
